window.Products.Clothing.YogaCapris = function() {
};
window.Products.Clothing.YogaCapris.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.YogaCapris.id = 58;
window.Products.Clothing.YogaCapris.slug = 'yoga-capris';
window.Products.Clothing.YogaCapris.has_3d = true;
window.Products.Clothing.YogaCapris.dpi = 150;

window.Products.Clothing.YogaCapris.prototype.set3dProperties = function(modelViewer) {
    this.updateThreeTexture(modelViewer);
    modelViewer.object.position.y = 0.08;
    modelViewer.camera.position.z = 2.57;
    modelViewer.initalCameraPosition.z = -2.57;
};

window.Products.Clothing.YogaCapris.prototype.setThreeControls = function(controls) {
    controls.minDistance = 2.8;
    controls.maxDistance = 3.6;
};

window.Products.Clothing.YogaCapris.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.bumpScale = 0.0005;
    modelViewer.object.children[1].material.bumpScale = 0.0005;
};